import { NUMBER, INTEGER } from '@/plugins/sdk/fields'
import isFinite from 'lodash/isFinite'

export default {
  label: 'Equals',
  operator: 'equals',
  fields: [ NUMBER, INTEGER ],
  isValidValue (value) {
    return isFinite(value)
  }
}
